import { InformationBanner, Spinner } from "@graffer-inc/console-design-kit";
import { SettingsTemplate } from "../../../../../template/settings/default-template";
import { useQualifiedInvoiceBusinessIssuersEditHooks } from "../../../../../organisms/smart-apply/qualified-invoice/business-issuers/hooks/edit";
import { Redirect, useParams } from "react-router-dom";
import { SettingR } from "../../../route";
import { QualifiedInvoiceBusinessIssuersEditForm } from "../../../../../organisms/smart-apply/qualified-invoice/business-issuers/edit-form";
import { useAuthContextV2 } from "../../../../../../auth-state";

export const QualifiedInvoiceBusinessIssuerEditPage = () => {
  const authContext = useAuthContextV2();
  const { id } = useParams<{ id: string }>();

  const {
    enablePayment,
    redirectTo,
    isLoading,
    disabledSubmitButton,
    inputBusinessIssuerGroups,
    inputBusinessIssuerGroupsError,
    businessIssuer,
    orgGroupSelectOptions,
    handleOnSetRedirectToList,
    handleOnChangeGroupSearchKeyword,
    handleOnChangeBusinessIssuerGroups,
    handleOnSubmit,
  } = useQualifiedInvoiceBusinessIssuersEditHooks({
    id,
    orgId: authContext.auth.data?.orgId!,
    auth: authContext.auth,
  });

  if (redirectTo === "list") {
    return (
      <Redirect to={SettingR.QualifiedInvoiceBusinessIssuersIndex.link({})} />
    );
  }

  if (!authContext.auth.hasPermissions("invoice_business_issuers.update")) {
    return <></>;
  }

  return (
    <SettingsTemplate breadcrumbs={[]}>
      <Spinner loading={isLoading} />
      <div>
        <nav className="level">
          <div className="level-left">
            <div className="level-item">
              <h1 className="title">適格請求書発行事業者</h1>
            </div>
          </div>
        </nav>
      </div>
      <div className="c-use-detail--wrapper__half mt-6">
        {enablePayment ? (
          <>
            {businessIssuer ? (
              <QualifiedInvoiceBusinessIssuersEditForm
                disabledSubmitButton={disabledSubmitButton}
                inputBusinessIssuerGroups={inputBusinessIssuerGroups}
                inputBusinessIssuerGroupsError={inputBusinessIssuerGroupsError}
                businessIssuer={businessIssuer}
                orgGroupSelectOptions={orgGroupSelectOptions}
                handleOnSetRedirectToList={handleOnSetRedirectToList}
                handleOnChangeGroupSearchKeyword={
                  handleOnChangeGroupSearchKeyword
                }
                handleOnChangeBusinessIssuerGroups={
                  handleOnChangeBusinessIssuerGroups
                }
                handleOnSubmit={handleOnSubmit}
              />
            ) : (
              <></>
            )}
          </>
        ) : (
          <InformationBanner message="決済設定が無効のため、適格請求書発行事業者の編集はできません。" />
        )}
      </div>
    </SettingsTemplate>
  );
};
